<div class="main-content">
  <div class="profile-header">
    <h1>{{ "userprofile_your_profile" | translate }}</h1>
  </div>
  <mat-divider></mat-divider>
  <div>
    <form [formGroup]="userProfileFormGroup" class="profile-form">
      <div data-testid="user_profile_photo" (click)="profileImageOnClick()">
        <mat-icon class="color-city-blue profile-camera-icon"
          >camera_enhance</mat-icon
        >
        @if (profileImgLink) {
        <img
          [src]="profileImgLink | safe : 'resourceUrl'"
          (error)="profileImgLink = ''"
          class="profile-image"
        />
        } @if (!profileImgLink) {
        <mat-icon class="profile-image-empty-icon">account_circle</mat-icon>
        }
      </div>
      @if (newImagePath) {
      <div>
        <div class="divider"></div>
        <button
          mat-raised-button
          (click)="savePhotoOnClick()"
          id="btn_savephoto"
          data-testid="user_profile_save_photo"
        >
          {{ "userprofile_btn_update_photo" | translate }}
        </button>
      </div>
      }
      <div class="divider"></div>
      <div class="divider"></div>
      <mat-divider></mat-divider>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">{{
          "userprofile_first_name" | translate
        }}</mat-label>
        <input
          matInput
          disabled
          value="{{ firstName }}"
          data-testid="user_profile_first_name"
        />
      </mat-form-field>
      <mat-divider></mat-divider>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">{{
          "userprofile_last_name" | translate
        }}</mat-label>
        <input
          matInput
          disabled
          value="{{ lastName }}"
          data-testid="user_profile_last_name"
        />
      </mat-form-field>
      <mat-divider></mat-divider>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">{{
          "userprofile_phone" | translate
        }}</mat-label>
        <input
          matInput
          disabled
          value="{{ phoneNumber }}"
          data-testid="user_profile_phone"
        />
      </mat-form-field>
      <mat-divider></mat-divider>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">{{
          "userprofile_email" | translate
        }}</mat-label>
        <input
          matInput
          disabled
          value="{{ emailAddress }}"
          data-testid="user_profile_email"
        />
      </mat-form-field>
      <mat-divider></mat-divider>
    </form>

    @if (isDebugModeActive) {
    <div>
      <h3>Debug Information</h3>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">App Version</mat-label>
        <input
          matInput
          disabled
          value="{{ appVersion }}"
          data-testid="user_profile_app_version"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">Date Time</mat-label>
        <input
          matInput
          disabled
          value="{{ currentDateTime | date : 'medium' }}"
          data-testid="user_profile_date_time"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">Device Info</mat-label>
        <textarea
          matInput
          disabled
          value="{{ deviceInfo }}"
          data-testid="user_profile_device_info"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
        ></textarea>
      </mat-form-field>
      <mat-form-field appearance="fill" class="input">
        <mat-label class="color-city-neutral">Current Lat Long</mat-label>
        <input
          matInput
          disabled
          value="{{ userLatLong }}"
          data-testid="user_profile_lat_long"
        />
      </mat-form-field>
      <button
        type="btn_updatelocation"
        mat-raised-button
        id="btn_updatelocation"
        data-testid="user_profile_update_location"
        (click)="updateLocationOnClick()"
      >
        Update Location
      </button>
      <div class="divider"></div>
      <button
        type="btn_senddebuginfo"
        mat-raised-button
        id="btn_senddebuginfo"
        data-testid="user_profile_send_debug_info"
        (click)="sendDebugInfoOnClick()"
      >
        Send Debug Info
      </button>
      <mat-divider></mat-divider>
      <div class="divider"></div>
    </div>
    } @if (isMutliLanguageEnable && languages.length >= 1) {
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label class="color-city-blue">{{
        "lbl_language" | translate
      }}</mat-label>
      <mat-select
        id="sel-language"
        name="sel-language"
        [(value)]="language"
        (selectionChange)="onLangSelect($event.value)"
      >
        @for (lang of languages; track lang) {
        <mat-option [value]="lang.code">
          {{ lang.description }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
  </div>

  @if (inductionModuleEnable && profileRapidGlobalRequired) {
  <div class="form-list">
    <div fxLayout="row" fxLayoutAlign="space-between end">
      <h5>
        {{ "userprofile_rapid_global_header" | translate }}
        <mat-icon>help_outline</mat-icon>
      </h5>
      <button
        id="btn_addrapidglobal"
        mat-fab
        (click)="addRapidGlobal()"
        data-testid="user_profile_add_rapid_global"
      >
        <mat-icon>note_add</mat-icon>
      </button>
    </div>
    <div class="divider"></div>
    <mat-divider class="table-divider-header"></mat-divider>
    <div>
      <table mat-table [dataSource]="rapidGlobalInfos" multiTemplateDataRows>
        <ng-container matColumnDef="companyName">
          <th
            mat-header-cell
            *matHeaderCellDef
            fxFlex="75"
            fxLayoutAlign="start center"
          >
            {{ "userprofile_rapid_global_company_table_header" | translate }}
          </th>
          <td
            mat-cell
            class="color-dark-blue"
            *matCellDef="let company"
            fxFlex="75"
            fxLayoutAlign="start center"
          >
            {{ company.companyName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            fxFlex="25"
            fxLayoutAlign="end center"
          ></th>
          <td
            mat-cell
            *matCellDef="let company"
            fxFlex="25"
            fxLayoutAlign="end center"
          >
            @if (!company.companyId) {
            <mat-icon
              color="primary"
              (click)="editRapidGlobal(company)"
              data-testid="user_management_rapid_edit_icon"
            >
              edit
            </mat-icon>
            } @if (!company.companyId) {
            <mat-icon
              color="primary"
              (click)="deleteRapidGlobal(company)"
              data-testid="user_management_rapid_delete_icon"
            >
              delete
            </mat-icon>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedRapidGlobalColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedRapidGlobalColumns"
          class="element-row"
        ></tr>
      </table>
      <div class="divider"></div>
      <div class="divider"></div>
    </div>
  </div>
  } @if (!isSSO) {
  <div>
    <div>
      <button
        mat-raised-button
        type="submit"
        class="change-button"
        (click)="updateUserDetails()"
        id="btn_changeUserDetails"
        data-testid="user_profile_update_user"
      >
        {{ "userprofile_update_details" | translate }}
      </button>
      <button
        mat-raised-button
        type="submit"
        class="change-button"
        (click)="changepassword()"
        id="btn_changepassword"
        data-testid="user_profile_change_password"
      >
        {{ "userprofile_change_password" | translate }}
      </button>
    </div>
    <div class="divider"></div>
    <div class="deactivate-user">
      <a
        class="color-city-blue"
        id="btn_deactivateuser"
        data-testid="btn_deactivate_user"
        (click)="deactivateUser()"
        >{{ "user_profile_deactivate_user" | translate }}</a
      >
    </div>
  </div>
  }

  <div class="divider"></div>
  @if (inductionModuleEnable && profileInductionRequired) {
  <div class="form-list">
    <div fxLayout="row" fxLayoutAlign="space-between end">
      <h5>
        {{ "userprofile_siteinduction_header" | translate }}
        <mat-icon>help_outline</mat-icon>
      </h5>
      <button
        id="btn_addInduction"
        mat-fab
        color="primary"
        (click)="addSiteInduction()"
        data-testid="user_profile_add_site_induction"
      >
        <mat-icon>note_add</mat-icon>
      </button>
    </div>
    <div class="divider"></div>
    <mat-divider class="table-divider-header"></mat-divider>
    <div>
      <table mat-table [dataSource]="siteInductionInfos" multiTemplateDataRows>
        <ng-container matColumnDef="brandName">
          <th
            mat-header-cell
            *matHeaderCellDef
            fxFlex="75"
            fxLayoutAlign="start center"
          >
            {{ "userprofile_siteinduction_partner_table_header" | translate }}
          </th>
          <td
            mat-cell
            class="color-dark-blue"
            *matCellDef="let siteinduction"
            fxFlex="75"
            fxLayoutAlign="start center"
          >
            {{ siteinduction.brandName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            fxFlex="25"
            fxLayoutAlign="end center"
          >
            {{ "userprofile_siteinduction_status_table_header" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let siteinduction"
            fxFlex="25"
            fxLayoutAlign="end center"
          >
            @if (getStatus(siteinduction) === SiteInductionStatus.COMPLIANCE) {
            <mat-icon class="color-city-green">check_circle</mat-icon>
            } @if (getStatus(siteinduction) === SiteInductionStatus.EXPIRED) {
            <mat-icon class="color-city-red">cancel</mat-icon>
            <span class="color-city-red induction-expired-label">{{ "userprofile_siteinduction_expired" | translate }}</span>
            } @if (getStatus(siteinduction) === SiteInductionStatus.NON_COMPLIANCE) {
            <mat-icon class="color-city-red">cancel</mat-icon>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="expandedInductionDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedSiteInductionColumns.length"
          >
            <div
              class="element-detail"
              [@detailInductionExpand]="
                element.isExpanded ? 'expanded' : 'collapsed'
              "
            >
              <div fxLayout="column" fxFlex="100" class="induction-detail-content">
                <div fxLayout="row" fxLayoutAlign="start center" class="induction-detail-row">
                  <div
                    fxFlex="82"
                    class="expanded-header-label color-city-neutral"
                    fxLayoutAlign="start center"
                  >
                    {{ "userprofile_siteinduction_id" | translate }}
                    {{ element.inductionId }}
                  </div>
                  <div
                    fxFlex="18"
                    fxLayout="row"
                    fxLayoutAlign="end center"
                    class="induction-detail-actions"
                  >
                    <mat-icon
                      color="primary"
                      (click)="editSiteInduction(element); $event.stopPropagation()"
                      data-testid="user_management_induction_edit_icon"
                    >
                      edit
                    </mat-icon>
                    <mat-icon
                      color="primary"
                      (click)="deleteSiteInduction(element); $event.stopPropagation()"
                      data-testid="user_management_induction_delete_icon"
                    >
                      delete
                    </mat-icon>
                  </div>
                </div>
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  class="induction-detail-row induction-detail-expiry-row"
                >
                  <div
                    fxFlex="100"
                    class="expanded-header-label color-city-neutral"
                    fxLayoutAlign="start center"
                  >
                    {{ "userprofile_siteinduction_expirydate" | translate }}
                    @if (element.expiryDate) {
                    {{ element.expiryDate | date : "dd/MM/yyyy" }}
                    } @else {
                    —
                    }
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedSiteInductionColumns"
        ></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedSiteInductionColumns"
          class="element-row"
          [class.expanded-row]="element.isExpanded"
          (click)="element.isExpanded = !element.isExpanded"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedInductionDetail']"
          class="detail-row"
        ></tr>
      </table>
    </div>
  </div>
  }

  <div class="close-button">
    <button
      type="submit"
      mat-raised-button
      id="userprofile_close"
      data-testid="userprofile_close"
      (click)="closeUserProfile()"
    >
      {{ "userprofile_close" | translate }}
    </button>
  </div>
</div>
